import React, { useState } from "react";
import { auth, db } from "./firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import Navbar from "./Navbar";
import { useNavigate } from "react-router-dom";

const C = {
  bg:"#0a0a0f", surface:"rgba(255,255,255,0.04)", sh:"rgba(255,255,255,0.07)",
  border:"rgba(255,255,255,0.08)", text:"#f5f5f7",
  sec:"rgba(245,245,247,0.55)", ter:"rgba(245,245,247,0.30)",
  accent:"#0a84ff", green:"#30d158", red:"#ff453a",
};
const F = "-apple-system,'SF Pro Display','Helvetica Neue',sans-serif";

const inp = { width:"100%", padding:"0.72rem 0.9rem", background:"rgba(255,255,255,0.05)", border:"1px solid rgba(255,255,255,0.09)", borderRadius:12, color:C.text, fontSize:"0.9rem", boxSizing:"border-box", outline:"none", fontFamily:F, marginBottom:"1rem" };

export default function RegistrazioneUtente() {
  const [form, setForm] = useState({ nome:"", email:"", password:"", ruolo:"", localeTag:"" });
  const [messaggio, setMessaggio] = useState("");
  const [emailEsistente, setEmailEsistente] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessaggio("");
    setEmailEsistente(false);
    setLoading(true);
    try {
      const cred = await createUserWithEmailAndPassword(auth, form.email, form.password);
      await setDoc(doc(db, "utenti", cred.user.uid), { nome:form.nome, email:form.email, ruolo:form.ruolo.toLowerCase(), localeTag:form.localeTag });
      setMessaggio("✅ Utente creato con successo.");
      setForm({ nome:"", email:"", password:"", ruolo:"", localeTag:"" });
      navigate("/");
    } catch (e) {
      const code = e?.code || "";

      if (code.includes("auth/email-already-in-use")) {
        setMessaggio("Questa email è già registrata.");
        setEmailEsistente(true);
      } else if (code.includes("auth/invalid-email")) {
        setMessaggio("Email non valida.");
        setEmailEsistente(false);
      } else if (code.includes("auth/weak-password")) {
        setMessaggio("Password troppo debole (minimo 6 caratteri).");
        setEmailEsistente(false);
      } else {
        setMessaggio("Errore durante la registrazione.");
        setEmailEsistente(false);
      }
    }
    setLoading(false);
  };

  const isOk = messaggio.startsWith("✅");

  return (
    <>
      <Navbar />
      <div style={{ minHeight:"100vh", background:C.bg, fontFamily:F, color:C.text }}>
        <div className="page-with-navbar" style={{ maxWidth:560, margin:"0 auto" }}>

          <div style={{ marginBottom:"2rem" }}>
            <p style={{ margin:"0 0 0.25rem", fontSize:"0.72rem", color:C.sec, fontWeight:500 }}>Gestione utenti</p>
            <h1 style={{ margin:0, fontSize:"clamp(1.4rem,3vw,1.9rem)", fontWeight:700, letterSpacing:"-0.5px" }}>Registra utente</h1>
          </div>

          {messaggio && (
            <div style={{
              padding:"0.75rem 1rem",
              borderRadius:12,
              marginBottom:"1.25rem",
              fontSize:"0.82rem",
              fontWeight:600,
              background: isOk?"rgba(48,209,88,0.1)":"rgba(255,69,58,0.1)",
              border:`1px solid ${isOk?"rgba(48,209,88,0.25)":"rgba(255,69,58,0.25)"}`,
              color: isOk?C.green:C.red
            }}>
              {messaggio}

              {emailEsistente && (
                <div style={{ marginTop:"0.6rem", display:"flex", gap:"8px" }}>
                  <button
                    onClick={() => navigate("/login", { state: { email: form.email } })}
                    style={{
                      padding:"0.4rem 0.7rem",
                      borderRadius:8,
                      border:"none",
                      background:"#0a84ff",
                      color:"#fff",
                      cursor:"pointer",
                      fontSize:"0.75rem"
                    }}
                  >
                    Accedi
                  </button>

                  <button
                    onClick={() => navigate("/login", { state: { email: form.email } })}
                    style={{
                      padding:"0.4rem 0.7rem",
                      borderRadius:8,
                      border:"1px solid rgba(255,255,255,0.2)",
                      background:"transparent",
                      color:"#fff",
                      cursor:"pointer",
                      fontSize:"0.75rem"
                    }}
                  >
                    Recupera password
                  </button>
                </div>
              )}
            </div>
          )}

          <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:20, padding:"1.5rem" }}>
            <form onSubmit={handleSubmit}>
              <label style={{ display:"block", marginBottom:"0.3rem", fontSize:"0.72rem", color:C.sec, fontWeight:500 }}>Nome</label>
              <input style={inp} type="text" value={form.nome} onChange={e=>setForm({...form,nome:e.target.value})} required placeholder="Mario Rossi"
                onFocus={e=>e.target.style.borderColor=C.accent+"88"} onBlur={e=>e.target.style.borderColor="rgba(255,255,255,0.09)"} />

              <label style={{ display:"block", marginBottom:"0.3rem", fontSize:"0.72rem", color:C.sec, fontWeight:500 }}>Email</label>
              <input style={inp} type="email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} required placeholder="utente@esempio.it"
                onFocus={e=>e.target.style.borderColor=C.accent+"88"} onBlur={e=>e.target.style.borderColor="rgba(255,255,255,0.09)"} />

              <label style={{ display:"block", marginBottom:"0.3rem", fontSize:"0.72rem", color:C.sec, fontWeight:500 }}>Password</label>
              <input style={inp} type="password" value={form.password} onChange={e=>setForm({...form,password:e.target.value})} required placeholder="min. 6 caratteri"
                onFocus={e=>e.target.style.borderColor=C.accent+"88"} onBlur={e=>e.target.style.borderColor="rgba(255,255,255,0.09)"} />

              <label style={{ display:"block", marginBottom:"0.3rem", fontSize:"0.72rem", color:C.sec, fontWeight:500 }}>Ruolo</label>
              <select style={{ ...inp, cursor:"pointer" }} value={form.ruolo} onChange={e=>setForm({...form,ruolo:e.target.value})} required
                onFocus={e=>e.target.style.borderColor=C.accent+"88"} onBlur={e=>e.target.style.borderColor="rgba(255,255,255,0.09)"}>
                <option value="">Seleziona ruolo</option>
                <option value="admin">Admin</option>
                <option value="gestore">Gestore</option>
                <option value="cassa">Cassa</option>
              </select>

              <label style={{ display:"block", marginBottom:"0.3rem", fontSize:"0.72rem", color:C.sec, fontWeight:500 }}>LocaleTag</label>
              <input style={inp} type="text" value={form.localeTag} onChange={e=>setForm({...form,localeTag:e.target.value})} required placeholder="es. capriccio"
                onFocus={e=>e.target.style.borderColor=C.accent+"88"} onBlur={e=>e.target.style.borderColor="rgba(255,255,255,0.09)"} />

              <button type="submit" disabled={loading} style={{ width:"100%", padding:"0.85rem", background: loading?C.accent+"60":C.accent, border:"none", borderRadius:12, color:"#fff", fontSize:"0.9rem", fontWeight:600, cursor: loading?"not-allowed":"pointer", fontFamily:F, transition:"background 160ms ease" }}
                onMouseEnter={e=>{ if(!loading) e.currentTarget.style.background="#007AEB"; }}
                onMouseLeave={e=>{ if(!loading) e.currentTarget.style.background=C.accent; }}>
                {loading ? "Creazione in corso…" : "Crea utente"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
